module.exports = __webpack_public_path__ + "media/images/scribe-course-cfd2b976.png";